// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/public-page.scss
// module id = 200
// module chunks = 3